import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { GateDefectsState } from "@/hooks/useGateDefects";

interface GateDefectsCardProps {
  state: GateDefectsState;
}

export function GateDefectsCard({ state }: GateDefectsCardProps) {
  const { t } = useTranslation();
  const { summary, forbidden, error } = state;

  return (
    <Card data-testid="gate-defects-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium">{t("executive.gateDefects.title")}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {forbidden ? (
          <p className="text-sm text-muted-foreground">{t("executive.gateDefects.unavailable")}</p>
        ) : error ? (
          <p className="text-sm text-muted-foreground">{t("executive.gateDefects.loadError")}</p>
        ) : summary.total === 0 ? (
          <p className="text-sm text-muted-foreground">{t("executive.gateDefects.empty")}</p>
        ) : (
          <>
            <p className="text-2xl font-semibold">
              {summary.total}{" "}
              <span className="text-sm font-normal text-muted-foreground">
                {t("executive.gateDefects.caption")}
              </span>
            </p>
            <ul className="space-y-1 text-xs text-muted-foreground">
              {summary.byGate.map((g) => (
                <li key={g.gate} className="flex justify-between">
                  <span>{g.gate}</span>
                  <span className="font-medium text-foreground">{g.count}</span>
                </li>
              ))}
            </ul>
          </>
        )}
      </CardContent>
    </Card>
  );
}
